export const contextPath = process.env.CONTEXT_PATH;
export const ROUTES = [
  { id: "1", url: `${contextPath}`, label: "Home", active: false },
  {
    id: "2",
    url: `${contextPath}/your-rewards`,
    label: "Rewards & Offers",
    active: false,
  },
  {
    id: "3",
    url: `${contextPath}/scan-code`,
    label: "Scan",
    active: false,
  },
  {
    id: "6",
    url: `${contextPath}/your-history`,
    label: "My History",
    active: false,
  },
  {
    id: "7",
    url: `${contextPath}/profile`,
    label: "Profile & Settings",
    active: false,
  },
  {
    id: "4",
    url: `${contextPath}/enter-coupon`,
    label: "Redeem a Coupon",
    active: false,
  },
  {
    id: "8",
    url: `${contextPath}/about`,
    label: "About the Program",
    active: false,
  }
];
